import React, { useState, useEffect, useContext } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Stepper, StepConnector, StepIcon, StepIconProps, Tooltip } from '@material-ui/core';
import { AppStateType } from "../../../redux/reducers";
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from "@mui/material/Typography";
import { Box, withStyles } from '@material-ui/core';
import { ArrowRightAlt, KeyboardBackspace } from "@material-ui/icons";
import PropertyForm from './PropertyForm'
import FacilitiesForm from './FacilitiesForm'
import { useDispatch, useSelector } from "react-redux";
import {
    partialUpdateProperty
} from "../../../redux/actions/propertyActions";
import A11yUnitsPage from "./A11yUnitsPage"
import StartDialog from "./StartDialog"
import { QuestionnaireContext } from '../../../components/contexts/QuestionnaireContext';
import DoneIcon from '@material-ui/icons/Done';
import { route, urls, useRouting } from '../../../routes';
import { MenuQuestionnaire } from './EditProperty';
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            paddingBottom: '140px'

        },
        instructions: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        activeStepperLabel: {
            background: "linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%)",
            "-webkit-background-clip": "text",
            " -webkit-text-fill-color": "transparent",
        },
        stepLabel: {
            color: "#78909C"
        },
        tooltip: {
            fontSize: "16px",
            zIndex: 9999999999999,
        },
        contentWrapper: {
            padding: "48px",
            [theme.breakpoints.down("sm")]: {
                marginTop: "20px",
                padding: "0px",
            },
        }
    }),
);

const stepIconStyles = makeStyles({
    root: {
        backgroundColor: "rgba(120, 144, 156, 0.8)",
        zIndex: 1,
        color: "#1e293a",
        fontSize: "0.9rem",
        fontWeight: "bold",
        width: "1.7rem",
        height: "1.7rem",
        display: "flex",
        borderRadius: "50%",
        justifyContent: "center",
        alignItems: "center"
    },
    active: {
        backgroundImage: "linear-gradient(90deg,#84FAB0 0%,#8FEAFE 100%)"
    },
    completed: {
        backgroundImage: "linear-gradient(90deg,#84FAB0 0%,#8FEAFE 100%)"
    }
});

type StepperProps = {
    activeStep: number
}

const StepperBox = styled.div<StepperProps>`
    display: flex;
    justify-content: ${(props) => (props?.activeStep !== 0) ? "space-between" : "flex-end"};
    background: linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);
    position: fixed;
    bottom: 0;
    width: 100vw;
    z-index: 5;
    padding: 10px;
`;

const StyledButton = withStyles({
    root: {
        border: '1px solid black',
        color: 'black',
    },
})(Button);

const CustomConnector = withStyles({
    active: {
        '& $line': {
            backgroundImage:
                'linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);',
        },
    },
    completed: {
        '& $line': {
            backgroundImage:
                'linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);',
        },
    },
    line: {
        height: 1,
        border: 0,
        backgroundColor: 'rgba(120, 144, 156, 0.8);',
        borderRadius: 1,
    },
})(StepConnector);

const CustomStepIcon = (props: any) => {
    const classes = stepIconStyles();
    const { active, completed, number } = props;

    return (
        <div
            className={`${classes.root} ${active ? classes.active : ""} ${completed ? classes.completed : ""}`}
        >
            {completed ? <DoneIcon /> : number}
        </div>
    );
}

export default function PropertyStepper() {
    const units = useSelector((state: AppStateType) => state.unitsReducer.units);
    const [checkedUnits, setCheckedUnits] = useState([])
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { routeTo } = useRouting();
    // const { navToClassification } = useContext(QuestionnaireContext);
    const property: any = useSelector((state: AppStateType) => state.propertyReducer.property)
    const user: any = useSelector((state: AppStateType) => state.authReducer.user)
    const [activeStep, setActiveStep] = React.useState(0);
    const [propertyFormValid, setPropertyFormValid] = React.useState(false);
    const [startDialog, setStartDialog] = React.useState(false);
    const [submitFnHandlers,] = React.useState({
        submitForm: () => Promise.resolve()
    });
    const [nextStepIsPressed, setNextStepIsPressed] = useState(false)

    function getSteps() {
        return [t("propertyForm_propertyStepper_step1"), t("propertyForm_propertyStepper_step2"), t("propertyForm_propertyStepper_step3")];
    }

    const steps = getSteps();
    useEffect(() => {
        if (activeStep === 2) onSaveFacilities(checkedUnits)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeStep])
    const onSaveFacilities = (steps?: string[]) => {
        if (steps) updatePropertyAccessibility(property?.id, user.token, steps)
    }

    const updatePropertyAccessibility = (id: any, token: any, steps: any) => {
        if (id) {
            const facilities = { "accessibility_unit_types": steps }
            dispatch(partialUpdateProperty(facilities, token, id))
        }
    }
    function isDisableButton() {
        if (propertyFormValid) {
            return false
        } else if (activeStep === 1) {
            return false
        } else if (activeStep === 2 && units?.length) {
            return false
        }
        return true
    }

    function getStepContent(stepIndex: number) {
        switch (stepIndex) {
            case 0:
                return <PropertyForm
                            onValidChange={isValid => setPropertyFormValid(isValid)}
                            nextStepIsPressed={nextStepIsPressed}
                            handleSubmitFn={fn => submitFnHandlers.submitForm = fn as any}
                        />;
            case 1:
                return <FacilitiesForm facilities={handleFacilities} />;
            case 2:
                // onSaveFacilities(checkedUnits)
                return <A11yUnitsPage />;
            default:
                return 'Unknown stepIndex';
        }
    }

    const handleFacilities = (facilities: any) => {
        setCheckedUnits(facilities)
    }

    const handleNext = async () => {
        setNextStepIsPressed(true)
        if (activeStep === 0) {
            if (!propertyFormValid) {
                return
            }
            await submitFnHandlers.submitForm();
        } else if (activeStep === 2) {
            setStartDialog(true)
            return
        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    const handleCloseDialog = async () => {
        setStartDialog(false)
        // navToClassification();
        if (property) {
            routeTo(urls.classify, { id: property?.id })
        }
    }
    return (
        <Box mb={12} width={'100%'}>
            <Box className={classes.contentWrapper}>
                <MenuQuestionnaire title={property?.name} />
                <StartDialog open={startDialog} onClose={handleCloseDialog} />
                <Stepper activeStep={activeStep} alternativeLabel connector={<CustomConnector />}>
                    {steps.map((label, index) => (
                        <Step key={label}>
                            <StepLabel
                                StepIconComponent={(props) => <CustomStepIcon number={index + 1}{...props} />}
                            >
                                <span className={`${activeStep === index ? classes.activeStepperLabel : classes.stepLabel}`}>{label}</span>
                            </StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <Box>
                    {activeStep === steps.length ? (
                        <div>
                            <Typography className={classes.instructions}>{t("propertyForm_AllStepsCompleted")}</Typography>
                            <Button onClick={handleReset}>{t("generalWords_Reset")}</Button>
                        </div>
                    ) : (
                        <Box>
                            <Box>{getStepContent(activeStep)}</Box>
                        </Box>
                    )}
                </Box>
            </Box>
            <StepperBox
                activeStep={activeStep}
                className="stepper-content-wrapper"
            >
                {activeStep !== 0 ? (
                    <StyledButton
                        onClick={handleBack}
                        variant="outlined"
                    >
                        <KeyboardBackspace />
                        {t("generalWords_Back")}
                    </StyledButton>
                ) : null}
                <Tooltip
                    title={
                        (isDisableButton()) ?
                            <span style={{ fontSize: "12px" }}>
                                {t("propertyForm_nextStep_tooltip")}
                            </span> 
                        : ""
                    } 
                    placement="left" 
                    arrow={true}
                >
                    <div>
                        <StyledButton
                            type="submit"
                            variant="outlined"
                            onClick={handleNext}
                        >
                            {activeStep === steps.length - 1 ? t("generalWords_Finish") : t("generalWords_NextStep")}
                            <ArrowRightAlt />
                        </StyledButton>
                    </div>
                </Tooltip>
            </StepperBox>
        </Box>
    );
}
